import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  PaycheckProtectionProgrampppStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';

export const fields: IBaseField<
  keyof PaycheckProtectionProgrampppStateValues
>[] = [
  {
    name: 'didYouReceivePaycheckProtectionProgrampppFunds',
    label: 'Did you receive Paycheck Protection Program (PPP) funds?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'howMuchPppMoneyDidYouReceive',
        label: 'How much PPP money did you receive?',
        type: 'number',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'yes',
        comment: true,
        dependencies: [
          {
            name: 'howMuchDidYouUseOnBusinessExpenses',
            label: 'How much did you use on business expenses?',
            type: 'number',
            effect: updateKeyInStore(updateKey),

            comment: true,
            predicate: (v) => v === 'yes',
          },
        ],
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
